/* eslint-disable max-len */
/* eslint-disable max-lines */
import { ReviewModel } from '../models';

const defaultAvatar = 'assets/images/user-content/default-avatar-small.png';
export const REVIEWS_DATA: ReviewModel[] = [
  {
    reviewType: 'quote',
    platformType: 'apple-store',
    text: 'With my new diet and the logging I do in Center Health, from February to May <strong>my A1c has dropped from 7.4 to 6.5</strong>. Thanks for the app!',
    author: 'Steve',
  },
  {
    reviewType: 'quote',
    platformType: 'apple-store',
    text: "First of all, the product <strong>LOOKS AMAZING</strong>. It's user-friendly, you guys have <strong>AMAZING</strong> support. And the most important thing: I can show these outputs to a doctor and he will understand.",
    author: 'Kevin',
  },
  {
    reviewType: 'instagram',
    postLink: 'https://www.instagram.com/p/BcDxYOehSH8',
    text: "I discovered not so long ago this amazing app called Center Health that my diabuddies created to <strong>help the diabetics in this world!</strong> Diabetes is affected by so many factors, so it's <strong>so helpful</strong> to manage everything in an app.",
    image: 'assets/images/user-content/hyper.hypo.jpg',
    author: 'Judy',
    authorAvatar: 'assets/images/user-content/hyper.hypo-avatar.jpg',
  },
  {
    reviewType: 'instagram',
    image: 'assets/images/user-content/michelle-2.jpg',
    text: "So I received my Nano today and I am beyond excited and pleased. I checked my blood sugar <strong>easier than I ever have in my 18 years</strong> of checking. If you're a diabetic, you should consider looking into getting one. I am so beyond pleased!",
    author: 'Michelle',
    authorAvatar: defaultAvatar,
  },
  {
    reviewType: 'quote',
    platformType: 'apple-store',
    text: 'This is super accurate! Has guessed spot on what my A1C is. <strong>It’s perfect!</strong>',
    author: 'Macus',
  },
  {
    reviewType: 'instagram',
    postLink: 'https://www.instagram.com/p/CFxkr3LFT5h',
    image: 'assets/images/user-content/t1tela.jpg',
    text: 'I <strong>LOVE the ease of this device</strong> and how it easily it integrated with my phone and other health apps. Being able to just plug it into my phone and check is super efficient plus it looks cool so people are more inclined to ask what im doing and I can happily explain!',
    author: 'Tela',
    authorAvatar: 'assets/images/user-content/t1tela-avatar.jpg',
  },
  {
    reviewType: 'quote',
    platformType: 'play-store',
    text: "This app and the equipment has honestly <strong>changed the way I manage my diabetes</strong>. I was terrible at testing regularly because my test strips were so expensive! But now with Center Health, I test like I should and the fact that it's on my phone reminds me to test whenever I see the app symbol. Thank you, Center Health!",
    author: 'Anna',
  },
  {
    reviewType: 'instagram',
    postLink: 'https://www.instagram.com/p/Bp-6mNNH6OZ',
    image: 'assets/images/user-content/kimssosocial.jpg',
    text: 'So this new little device is <strong>pretty awesome</strong>. It’s a glucose meter from @centerhealth_ I mainly purchased it because I could get glucose sticks cheaper through their subscription. They sent me a free meter and it plugs into our iPhones. 😍 And it has been very accurate so far and has basically been confirming the alerts dexcom gives us.',
    author: 'Kim',
    authorAvatar: 'assets/images/user-content/kimssosocial-avatar.jpg',
  },
  {
    reviewType: 'instagram',
    postLink: 'https://www.instagram.com/p/Byq3iTol3Cd',
    image: 'assets/images/user-content/briannakgibson.jpg',
    author: 'Brianna',
    authorAvatar: 'assets/images/user-content/briannakgibson-avatar.jpg',
  },
  {
    reviewType: 'quote',
    platformType: 'apple-store',
    text: 'This product <strong>has been a life saver</strong> not only to me but to my wallet. Only $29 a month and you get unlimited test strips. No insurance needed. The nano plugs right into your iPhone or Android',
    author: 'Dillon',
  },
  {
    reviewType: 'quote',
    platformType: 'apple-store',
    text: 'This meter has been wonderful. <strong>Easy to use and convenient</strong> to carry around. Customer service is amazing. They get back to you right away and are extremely helpful :)',
    author: 'Cheriann',
  },
  {
    reviewType: 'quote',
    platformType: 'apple-store',
    text: 'I give this little easy to carry device 5+ stars. The nano was free & I only pay $20 a month for strips. It helped me become <strong>diabetic free since October 2018</strong>! Thank you team nano.',
    author: 'Kraftycrochet',
  },
  {
    reviewType: 'quote',
    platformType: 'apple-store',
    text: 'Love the Center Health Nano. It fits anywhere! No more lugging around bulky meters to keep an eye on blood glucose levels. It even fits nicely into your pocket. Testing my glucose levels <strong>has never been so quick, easy and discreet</strong>!',
    author: 'mamadague',
  },
  {
    reviewType: 'instagram',
    postLink: 'https://www.instagram.com/p/BqunRmDATkI',
    image: 'assets/images/user-content/typeonemoney.jpg',
    text: 'I am very thankful for the diabetes technology that <strong>makes my life easier</strong> to live with the disease. I am excited to see what else will be developed/invented next!',
    author: 'Marleah',
    authorAvatar: 'assets/images/user-content/typeonemoney-avatar.jpg',
  },
  {
    reviewType: 'quote',
    platformType: 'apple-store',
    text: 'I love this app and the fact that I can have unlimited strips to my door before I ever run out. Thank you center health. I love how <strong>quick and responsive</strong> they are when sending an email or asking them a question.',
    author: 'Sandy',
  },
  {
    reviewType: 'instagram',
    image: 'assets/images/user-content/michelle-2.jpg',
    text: "So I received my Nano today and I am beyond excited and pleased. I checked my blood sugar <strong>easier than I ever have in my 18 years</strong> of checking. If you're a diabetic, you should consider looking into getting one. I am so beyond pleased!",
    author: 'Michelle',
    authorAvatar: defaultAvatar,
  },
  {
    reviewType: 'instagram',
    postLink: 'https://www.instagram.com/p/BqunRmDATkI',
    image: 'assets/images/user-content/minimoneyr56.jpg',
    author: 'Marleah',
    authorAvatar: 'assets/images/user-content/minimoneyr56-avatar.jpg',
  },
  {
    reviewType: 'instagram',
    postLink: 'https://www.instagram.com/p/B9Mw5TAlkRJ',
    image: 'assets/images/user-content/bonniesteeleforshey.jpg',
    text: 'If you are a diabetic, Center Health has a great glucometer that works with your cell phone. <strong>Easy to use, easy to carry</strong>, and an app that keeps track of all of your numbers. Very reasonable prices and a subscription plan for your strips!',
    author: 'Bonnie',
    authorAvatar: 'assets/images/user-content/bonniesteeleforshey-avatar.jpg',
  },
  {
    reviewType: 'quote',
    platformType: 'apple-store',
    text: '<strong>This app has been revolutionary</strong> in getting me to care for my diabetes by keeping up with my blood sugar numbers. I have had this disease for 24 years and I have never been so consistent with my numbers and what I am trending. I cannot recommend it enough! So simple to use too. Thank you Center!!!',
    author: 'Brytor',
  },
  {
    reviewType: 'quote',
    platformType: 'apple-store',
    text: 'Nano has <strong>made my life so much easier</strong>! The main reason I wasn’t checking my bgms is because logging it became too tedious. Now, everything is logged automatically, and taking my bgm is even kind of fun!',
    author: 'ShyHiler',
  },
];
export default REVIEWS_DATA;
